import axios from "axios";

const axiosClient = axios.create({
  baseURL: 'https://merntasks-server-evo.herokuapp.com',
});

export default axiosClient;
